import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCategoryReducer = () => useSelector((state: ApplicationState) => state.category);
